/***
 * 公用全局方法
 */
import { checkWord } from "@/api/smsSend";

export default {
  install(Vue) {
    // 短链接重复判断
    Vue.prototype.shopLinkCheck = function(e, link = "") {
      const preData = e.target.value + "!#123-"
      setTimeout(() => {
        const nextData = preData + e.target.value
        if(preData === "!#123-") {
          if(nextData.indexOf("3.cn/") != -1) {
            // e.target.value = preData.substring(0, preData.length - 6)
            this.$message.error("请勿复制或者重复使用短链接")
          }
          return
        }
        let arr = []
        arr = nextData.split(preData)
        const temp = arr[arr.length - 1]; // 数据处理获取复制内容
        const newArr = temp.split(preData.substring(0, preData.length - 6))
        const two = newArr.every((item) => {
          return item == "" 
        })
        if(two && temp.indexOf("3.cn/") != -1) {
          this.$message.error("请勿复制或者重复使用短链接")
          // e.target.value = preData.substring(0, preData.length - 6)
          return
        }
        const copyData = newArr[newArr.length - 1]
        // 判断重复短链接
        // if(preData.indexOf("3.cn/") != -1 && copyData.indexOf("3.cn/") != -1 && copyData.indexOf(link) != -1) {
        //   e.target.value = preData
        //   this.$message.error("请勿复制或者重复使用短链接")
        // }

        // 判断复制存在3.cn/xxxxxx时
        if(copyData.indexOf("3.cn/") != -1) {
          // e.target.value = preData.substring(0, preData.length - 6)
          this.$message.error("请勿复制或者重复使用短链接")
        }
      }, 10)
    },

    // 敏感词检测
    Vue.prototype.$wordCheck = async function(params) {
      return new Promise((resolve, reject) => {
        checkWord(params).then((result) => {
          resolve(result)
        }).catch((err) => {
          reject(err)
        });
      })
    }

    // 数字每3位加 ，
    Vue.prototype.$changeThreeNum = function(number) {
      if (!number) {
        return number;
      }
      const str = String(number)
      if (str.length && str.indexOf('.') != -1) {
          let num = Number(str)
          if (!num) num = 0
          num = num.toFixed(2)
          let c = num.split('.')
          let b = c[0].toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + c[1]
          return b
      } else {
          const reg = /(\d)(?=(?:\d{3})+$)/g;
          const newNumber = number.toString().replace(reg, "$1,");
          return newNumber;
      }
    }

    // #付款链接# #评价链接# 由实际字数转为 15 个字
    Vue.prototype.$linkConvertNum = function(content) {
      const str = content.replace(/#付款链接#/g, "###############").replace(/#评价链接#/g, "###############")
      return str.length
    }
  }
}